﻿import type { ReloadFormRequest } from 'apiConnector/secondary-market/cp-order/model';
import { isSecondaryMarketQuotesCpOrderPersistedTabContent } from 'apiConnector/tabs/secondaryMarket.tabs.model';
import { secondaryMarketCpOrderFormReset } from 'state/secondaryMarket/cpOrder/cpOrderForm';
import {
  secondaryMarketCpOrderInitFormFetchRequested,
  secondaryMarketCpOrderReloadFormFetchRequested,
} from 'state/secondaryMarket/cpOrder/referential/product/product.actions';
import { toBcsProductKey } from 'state/secondaryMarket/utils';
import { fromSecondaryQuotesWorkspace } from 'state/selectors';
import type { Thunk } from 'state/state.common';

import { getCpOrderTabContentToPersist } from './cpOrderForm/input/cpOrderInputForm.selectors';

export function secondaryCpOrderResetTabThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const bcsKey = fromSecondaryQuotesWorkspace.getProductKey(state, tabId);
    const bcsProductKey = toBcsProductKey(bcsKey);
    if (bcsProductKey === undefined) {
      return;
    }
    dispatch(secondaryMarketCpOrderFormReset(tabId));
    dispatch(secondaryMarketCpOrderInitFormFetchRequested(tabId, bcsProductKey));
  };
}

export function reloadTabThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const tabContent = getCpOrderTabContentToPersist(state, tabId);
    if (!tabContent || !isSecondaryMarketQuotesCpOrderPersistedTabContent(tabContent)) {
      return;
    }

    const request: ReloadFormRequest = {
      clientType: tabContent.clientType,
      client: tabContent.client,
      custodian: tabContent.custodian,
      valuationDate: tabContent.valuationDate,
      settlementDate: tabContent.settlementDate,
      salesId: tabContent.salesId,
      bcsProductKey: toBcsProductKey(tabContent?.bcsProductKey)!,
    };
    dispatch(secondaryMarketCpOrderReloadFormFetchRequested(tabId, 'secondaryMarketQuotes', request));
  };
}
